var map = {
	"./messages-de.json": 475,
	"./messages-en.json": 476,
	"./messages-es.json": 477,
	"./messages-fr.json": 478,
	"./messages-it.json": 479,
	"./messages-ja.json": 480,
	"./messages-ko.json": 481,
	"./messages-zh.json": 482
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 474;